// extracted by mini-css-extract-plugin
export var btn = "ContactModal-module--btn--df9cf";
export var form = "ContactModal-module--form--4955b";
export var info = "ContactModal-module--info--15ed2";
export var inner = "ContactModal-module--inner--78140";
export var modal = "ContactModal-module--modal--1d20e";
export var whatsapp = "ContactModal-module--whatsapp--0861b";